import React from 'react';
import PropTypes from 'prop-types';
import UniversalLineWithComponents from '../../components/components/universal_line_with_components/universalLineWithComponents.jsx';
import customText from '../../components/components/custom_text/customText.jsx';

import { ReactComponent as Play } from '../../components/icons/play.svg';
import { ReactComponent as ThreePeople } from '../../components/icons/people.svg';

function UserDataContainer({ statsData }) {
  // Dane statystyczne podzielone na trzy kolumny
  const { usersStats, ageStats} = statsData;

  return (
    <div className="stats-row-container">
      <div className="stats-column">
          <UniversalLineWithComponents
              basicStyle='line-with-components-without-borders'
              leftSide={[{
                  component: customText,
                  props: {
                      icon: ThreePeople,
                      text: 'Płeć',
                      baseClass: 'custom-text-header',
                  },
              }]}
              rightSide={[]}
          />
        <UniversalLineWithComponents 
          basicStyle='line-with-components-without-borders' 
          leftSide={[{
            component: customText,
            props: {
              text: 'Kobiety',
              baseClass: 'custom-text',
            },
          }]} 
          rightSide={[{
            component: customText,
            props: {
              text: usersStats.female,
              baseClass: 'custom-text-negative',
              borders: 'LRBT'
            },
          }]} 
        />
        <UniversalLineWithComponents 
          basicStyle='line-with-components-without-borders' 
          leftSide={[{
            component: customText,
            props: {
              text: 'Mężczyźni',
              baseClass: 'custom-text',
            },
          }]} 
          rightSide={[{
            component: customText,
            props: {
              text: usersStats.male,
              baseClass: 'custom-text-negative',
              borders: 'LRBT'
            },
          }]} 
        />
        <UniversalLineWithComponents 
          basicStyle='line-with-components-without-borders' 
          leftSide={[{
            component: customText,
            props: {
              text: 'Niezdecydowani',
              baseClass: 'custom-text',
            },
          }]} 
          rightSide={[{
            component: customText,
            props: {
              text: usersStats.others,
              baseClass: 'custom-text-negative',
              borders: 'LRBT'
            },
          }]} 
        />
          <UniversalLineWithComponents
              basicStyle='line-with-components-without-borders'
              leftSide={[{
                  component: customText,
                  props: {
                      text: ' ',
                      baseClass: 'custom-text',
                  },
              }]}
              rightSide={[]}
          />
          <UniversalLineWithComponents
              basicStyle='line-with-components-without-borders'
              leftSide={[{
                  component: customText,
                  props: {
                      text: ' ',
                      baseClass: 'custom-text',
                  },
              }]}
              rightSide={[]}
          />
      </div>
      <div className="stats-column">
          <UniversalLineWithComponents
              basicStyle='line-with-components-without-borders'
              leftSide={[{
                  component: customText,
                  props: {
                      icon: Play,
                      text: 'Wiek',
                      baseClass: 'custom-text-header',
                  },
              }]}
              rightSide={[]}
          />
        <UniversalLineWithComponents 
          basicStyle='line-with-components-without-borders' 
          leftSide={[{
            component: customText,
            props: {
              text: '16 - 18',
              baseClass: 'custom-text',
            },
          }]} 
          rightSide={[{
            component: customText,
            props: {
              text: ageStats._16_18,
              baseClass: 'custom-text-negative',
              borders: 'LRBT'
            },
          }]} 
        />
        <UniversalLineWithComponents 
          basicStyle='line-with-components-without-borders' 
          leftSide={[{
            component: customText,
            props: {
              text: '19 - 25',
              baseClass: 'custom-text',
            },
          }]} 
          rightSide={[{
            component: customText,
            props: {
              text: ageStats._19_25,
              baseClass: 'custom-text-negative',
              borders: 'LRBT'
            },
          }]} 
        />

          <UniversalLineWithComponents
              basicStyle='line-with-components-without-borders'
              leftSide={[{
                  component: customText,
                  props: {
                      text: '26 - 35',
                      baseClass: 'custom-text',
                  },
              }]}
              rightSide={[{
                  component: customText,
                  props: {
                      text: ageStats._26_35,
                      baseClass: 'custom-text-negative',
                      borders: 'LRBT'
                  },
              }]}
          />
          <UniversalLineWithComponents
              basicStyle='line-with-components-without-borders'
              leftSide={[{
                  component: customText,
                  props: {
                      text: '36 - 45',
                      baseClass: 'custom-text',
                  },
              }]}
              rightSide={[{
                  component: customText,
                  props: {
                      text: ageStats._36_45,
                      baseClass: 'custom-text-negative',
                      borders: 'LRBT'
                  },
              }]}
          />
          <UniversalLineWithComponents
              basicStyle='line-with-components-without-borders'
              leftSide={[{
                  component: customText,
                  props: {
                      text: '> 46',
                      baseClass: 'custom-text',
                  },
              }]}
              rightSide={[{
                  component: customText,
                  props: {
                      text: ageStats._46,
                      baseClass: 'custom-text-negative',
                      borders: 'LRBT'
                  },
              }]}
          />
      </div>
    </div>
  );
}

UserDataContainer.propTypes = {
  statsData: PropTypes.shape({
    usersStats: PropTypes.shape({
      female: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      male: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      others: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    }).isRequired,
    ageStats: PropTypes.shape({
      _16_18: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      _19_25: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      _26_35: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      _36_45: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      _46: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    }).isRequired,
  }).isRequired,
};

export default UserDataContainer;